<template>
  <OrganismsListsTabs :tabs="tabs" :selected-tab-index="props.selectedTabIndex" :max-enabled-index="props.maxEnabledIndex" />
</template>
<script setup>

const appConfig = useAppConfig();

const props = defineProps({
  maxEnabledIndex: Number,
  selectedTabIndex: Number
});

const i18n = useI18n();

const tabs = [
  { text: i18n.t('Obsah košíku'), href: appConfig.definedPageUrls.cart },
  { text: i18n.t('Doprava a platba'), href: appConfig.definedPageUrls.order },
  { text: i18n.t('Dodací údaje') },
  { text: i18n.t('Dokončení objednávky') }];

</script>